<template>
  <span  aria-hidden="true">
    <svg :width="iconSize"
         :height="iconSize"
         viewBox="0 0 28 28"
         xmlns="http://www.w3.org/2000/svg"
         :class="iconColor && `text-${iconColor}`"
         data-test="svg-icon"
    >
      <component :is="iconName" />
    </svg>
  </span>
</template>

<script>
import {defineAsyncComponent} from 'vue'

const ICON_NAMES = [
  'AcademyIcon',
  'AiChatIcon',
  'AiChatIconOutlined',
  'AiChatIconOutlinedBlack',
  'AiEditMagic',
  'AiFileMagic',
  'DaycareIcon',
  'GradeIcon',
  'InventoryIcon',
  'LessonIcon',
  'MediaLibraryIcon',
  'MeetingProtocolIcon',
  'MoreAddIcon',
  'ParentMeetingIcon',
  'SevenAssistantIcon',
  'SevenTimetableIcon',
  'SickIcon',
  'SocialManagementIcon',
  'AIPlannerIcon',
  'ChatHistoryIcon',
]

export default {
  name: 'SvgIcon',
  components: {
    AcademyIcon: defineAsyncComponent(() => import('src/components/icons/AcademyIcon.vue')),
    AiChatIcon: defineAsyncComponent(() => import('src/components/icons/AiChatIcon.vue')),
    AiChatIconOutlined: defineAsyncComponent(() => import('src/components/icons/AiChatIconOutlined.vue')),
    AiChatIconOutlinedBlack: defineAsyncComponent(() => import('src/components/icons/AiChatIconOutlinedBlack.vue')),
    AiEditMagic: defineAsyncComponent(() => import('src/components/icons/AiEditMagic.vue')),
    AiFileMagic: defineAsyncComponent(() => import('src/components/icons/AiFileMagic.vue')),
    DaycareIcon: defineAsyncComponent(() => import('src/components/icons/DaycareIcon.vue')),
    GradeIcon: defineAsyncComponent(() => import('src/components/icons/GradeIcon.vue')),
    InventoryIcon: defineAsyncComponent(() => import('src/components/icons/InventoryIcon.vue')),
    LessonIcon: defineAsyncComponent(() => import('src/components/icons/LessonIcon.vue')),
    MediaLibraryIcon: defineAsyncComponent(() => import('src/components/icons/MediaLibraryIcon.vue')),
    MeetingProtocolIcon: defineAsyncComponent(() => import('src/components/icons/MeetingProtocolIcon.vue')),
    MoreAddIcon: defineAsyncComponent(() => import('src/components/icons/MoreAddIcon.vue')),
    ParentMeetingIcon: defineAsyncComponent(() => import('src/components/icons/ParentMeetingIcon.vue')),
    SevenAssistantIcon: defineAsyncComponent(() => import('src/components/icons/SevenAssistantIcon.vue')),
    SevenTimetableIcon: defineAsyncComponent(() => import('src/components/icons/SevenTimetableIcon.vue')),
    SickIcon: defineAsyncComponent(() => import('src/components/icons/SickIcon.vue')),
    SocialManagementIcon: defineAsyncComponent(() => import('src/components/icons/SocialManagementIcon.vue')),
    AIPlannerIcon: defineAsyncComponent(() => import('src/components/icons/AIPlannerIcon.vue')),
    ChatHistoryIcon: defineAsyncComponent(() => import('src/components/icons/ChatHistoryIcon.vue')),
  },

  props: {
    iconName: {
      type: String,
      required: true,
      validator: (value) => ICON_NAMES.includes(value),
    },

    iconSize: {
      type: Number,
      default: 20
    },

    iconColor: {
      type: String,
      default: '',
    },
  },
}
</script>
